export default __webpack_public_path__ + "static/media/check.178d6794.svg";